<template>
<v-main>
<h2>Notification Settings</h2>
<v-container>
<v-checkbox color="red" label="Notify me of new subscribers" v-model="newSubscribers"></v-checkbox>
<v-checkbox color="red" label="Notify me of new tips payment" v-model="newPayment"></v-checkbox>
<v-checkbox color="red" label="Notify me of new features on Tippings" v-model="newTip"></v-checkbox>
<v-checkbox color="red" label="Notify me of withdrawal from my account" v-model="newWithdrawal"></v-checkbox>
</v-container>

</v-main>



</template>

<script>
export default{

data(){
return{
 newPayment:true,
 newWithdrawal:true,
 newTip:true,
 newSubscribers:true


}
}

}


</script>